export const lightTheme = {
  body: "hsl(0, 0%, 90%)",
  text: "hsl(207, 26%, 17%)",
  button: "hsl(0, 0%, 100%)",
  header: "hsl(0, 0%, 100%)",
};

export const darkTheme = {
  body: "hsl(207, 26%, 17%)",
  text: "hsl(0, 0%, 98%)",
  button: "hsl(209, 23%, 22%)",
  header: "hsl(209, 23%, 22%)",
};
